const STORAGE_KEY = 'extCustomerId';

const generateGuid = () => {
    if (window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

/**
 * @return {string}
 */
let cachedId = null;

export const getExtCustomerId = () => {
    if (cachedId) {
        return cachedId;
    }
    cachedId = localStorage.getItem(STORAGE_KEY);
    if (!cachedId) {
        cachedId = generateGuid();
        try {
            localStorage.setItem(STORAGE_KEY, cachedId);
        } catch {
            // storage full / blocked: keep the in-memory id for this page load instead of failing the request
        }
    }
    return cachedId;
};
